import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string | number;
  gatewayId: number;
  productKey: string;
}

export function useReplaceGateway() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, gatewayId, productKey }: Params) =>
      post({
        url: `/projects/${projectId}/gateways/${gatewayId}/replace`,
        body: {
          newProductKey: productKey,
        },
      }),
    onSuccess: (_, { projectId, installationId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallation(projectId, installationId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getGateways(projectId, 'installationId'),
      });
    },
  });

  const replaceGateway = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    replaceGateway,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
